import { useCometState, useEntropyBrowser, } from '#pplx/frontend/apps/ask/comet-browser/providers/EntropyBrowserHooks.js';
import { useCometGlobalTabsAttachmentsEnabledVariation } from '#pplx/frontend/apps/ask/generated/assignment-hooks/useCometGlobalTabsAttachmentsEnabledVariation.js';
import { getCometBrowserInfo, isCometBrowser } from '#pplx/frontend/comet/client/utils.js';
import { useMemo } from 'react';
export function useAskInputCometTabs() {
    const cometBrowser = useEntropyBrowser();
    const { attachedTabs, actions: { addAttachedTab, removeAttachedTab }, } = useCometState();
    const isCometBrowserCheck = isCometBrowser();
    const cometBrowserInfo = getCometBrowserInfo();
    const isAgentAvailable = cometBrowser.isAgentAvailable();
    const { variation: isGlobalTabsAttachmentsEnabled } = useCometGlobalTabsAttachmentsEnabledVariation({ defaultValue: false });
    const tabAttachmentsEnabled = isCometBrowserCheck &&
        Boolean(cometBrowserInfo?.is_personal_search_enabled) &&
        isAgentAvailable &&
        isGlobalTabsAttachmentsEnabled;
    return useMemo(() => {
        if (tabAttachmentsEnabled) {
            return {
                showCometTabs: true,
                attachedTabs,
                onAddTab: addAttachedTab,
                onRemoveTab: removeAttachedTab,
            };
        }
        return {
            showCometTabs: false,
        };
    }, [tabAttachmentsEnabled, attachedTabs, addAttachedTab, removeAttachedTab]);
}
//# sourceMappingURL=useAskInputCometTabs.js.map